var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","dark":"","color":"grey darken-3"}},[_c('div',{staticClass:"flex-grow-1"}),_c('span',{staticClass:"text-right"},[_vm._v("© "+_vm._s(_vm.$moment().year()))])])}
var staticRenderFns = []

export { render, staticRenderFns }